import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-version_management",
  "use": "icon-version_management-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-version_management\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M9.33,14v1.33h3.34V14Zm0-2.67v1.34h5.34V11.33Zm0-2.66V10h5.34V8.67Zm8,10H6.67A.67.67,0,0,1,6,18V6a.67.67,0,0,1,.67-.67H17.33A.67.67,0,0,1,18,6V18A.67.67,0,0,1,17.33,18.67Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol